var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.78 24.13h-2.202V28h-5.332v-3.87h-7.97v-3.964l8.312-12.154h4.99v12.086h2.201v4.033zm-7.534-4.032v-2.325c0-.437.014-1.025.041-1.763.037-.748.064-1.14.082-1.176h-.15c-.31.702-.661 1.358-1.053 1.969l-2.215 3.295h3.295z",
    fill: "#fff",
    fillOpacity: 0.2
  })));
}

export default SvgNumber4;